// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class VariableTick {
    constructor(dataObj) {
        var _a, _b;
        this.LeftBorder = (_a = dataObj.lowLimit) !== null && _a !== void 0 ? _a : 0;
        this.RightBorder = (_b = dataObj.highLimit) !== null && _b !== void 0 ? _b : 0;
        this.IncludeLeftBorder = dataObj.allowLimit;
        this.PointSize = dataObj.pointSize;
        this.TickCost = dataObj.tickCost;
    }
    /// <summary>
    /// проверка на вхождение
    /// </summary>
    CheckPrice(price) {
        if (isNaN(price)) {
            // если цена NaN - не находит никакой интервал
            price = -1;
        } // пока преобразовываем в -1 для проверки, чтоб было по старой схеме. TODO: подумать над решением лучше
        if (this.LeftBorder === Number.POSITIVE_INFINITY && this.RightBorder === Number.POSITIVE_INFINITY) {
            return true;
        }
        if (this.LeftBorder === Number.NEGATIVE_INFINITY) {
            return price < this.RightBorder;
        }
        else if (this.RightBorder === Number.POSITIVE_INFINITY) {
            return price >= this.LeftBorder;
        }
        else {
            return price >= this.LeftBorder && price < this.RightBorder;
        }
    }
    toString() {
        return (this.LeftBorder +
            (this.LeftBorder === Number.NEGATIVE_INFINITY ? '<= ' : '< ') +
            'price' +
            (this.RightBorder === Number.POSITIVE_INFINITY ? '<= ' : '< ') +
            this.RightBorder);
    }
}
